import { useQuery } from '@tanstack/react-query';
import { fetchDashboardHeaderData } from '../services/dashboardHeaderService';

export function useDashboardHeaderData(options = {}) {
  return useQuery({
    queryKey: ['dashboardHeaderData'],
    queryFn: fetchDashboardHeaderData,
    staleTime: 3 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: options.refetchOnMount ?? true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: {
      looking_for_categories: [],
    },
  });
}
